import React from "react";

const Back = ({ onClick, ...rest }) => (
    <nav className={ `back` } >
        <button tabIndex="0" className={ `back-button` }  onClick={ onClick } >
            <svg id="arrow"xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.19 31.29">
                <polygon points="31.19 15.14 1.91 15.14 16.35 0.71 15.64 0 0 15.64 15.64 31.29 16.35 30.58 1.91 16.14 31.19 16.14 31.19 15.14"/>
            </svg> 
        </button>
    </nav>
)

export default Back